import type {
  ISearchResultTileClickEvent,
  ISearchResultTileClickInput,
} from '../types/clickEvents';

const searchResultTileClick = (
  input: ISearchResultTileClickInput,
): Omit<ISearchResultTileClickEvent, 'event'> => ({
  ...input,
});

export default searchResultTileClick;
